import { countryList, states } from '../utils/Constants';

export class HsFormCfComponent {
	constructor(formSelector = '') {
		if (formSelector === '') {
			return;
		}

		let forms = [];
		let formsLength = 0;
		const formsInited = [];
		window.addEventListener('load', event => {
			let timesRun = 0;
			let countryFieldInterval = setInterval(function(){
				// run this function only 10 times
				timesRun++;
				if(timesRun === 10){
					clearInterval(countryFieldInterval);
				}
				console.log(`try N ${timesRun}`)
				forms = document.querySelectorAll(`${formSelector}`);

				if (forms.length > 0) {
					if (formsLength !== forms.length) {
						formsLength = forms.length;
						forms.forEach(form => {
							if (!formsInited.find(initedForm => initedForm === form)) {
								this.initializeForm(form);
								formsInited.push(form);
							}
						});
						clearInterval(countryFieldInterval);
					}
				}
			}.bind(this), 500);
		});
	}

	// New Version
	initializeForm(hsFormElement) {
		const countrySelect = this.createCountrySelect();
		const countryHSNativeField = hsFormElement?.querySelector(
			'input[name=country]'
		);
		if (!countryHSNativeField) {
			return;
		}

		countryHSNativeField.parentNode.appendChild(countrySelect);
		countrySelect.addEventListener('change', (e) =>
			this.countrySelectChangeHandler(
				e,
				hsFormElement,
				countryHSNativeField
			)
		);
	}

	createCountrySelect() {
		if (!Array.isArray(countryList)) {
			return '';
		}

		const select = document.createElement('select');
		select.classList.add('hs-input');
		select.name = 'hsf_country';
		select.setAttribute('required', 'required');
		select.innerHTML = `<option>${AssetsPath.translations.country} *</option>`;
		countryList.forEach((country) => {
			select.innerHTML += `<option value="${country}">${country}</option>`;
		});

		return select;
	}

	createStateSelect() {
		if (!Array.isArray(states)) {
			return '';
		}

		const select = document.createElement('select');
		select.classList.add('hs-input');
		select.classList.add('active');
		select.name = 'hsf_state';
		select.setAttribute('required', 'required');
		select.innerHTML += `<option value="">${AssetsPath.translations.state}</option>`;
		states.forEach((state) => {
			select.innerHTML += `<option value="${state}">${state}</option>`;
		});

		return select;
	}

	// Handles Country Select change event
	countrySelectChangeHandler(e, hsFormElement, countryHSNativeField) {
		const target = e.target;

		const countrySelectValue = target.selectedOptions[0].value;
		this.updateHSNativeCountryField(
			target.selectedOptions[0].value,
			countryHSNativeField
		);

		if (countrySelectValue === 'United States') {
			// Searching for Native State Field
			const stateHSNativeField =
				hsFormElement.querySelector('input[name=state]');
			if (!stateHSNativeField) {
				return;
			}

			const stateSelect = this.createStateSelect();
			if (stateSelect === '') {
				return;
			}

			stateHSNativeField.parentNode.appendChild(stateSelect);
			stateSelect.addEventListener('change', (e) =>
				this.stateSelectChangeHandler(e, stateHSNativeField)
			);
			this.updateHSNativeStateField(
				stateSelect.selectedOptions[0].value,
				stateHSNativeField
			);
		} else {
			const createdStateSelect = document.querySelector(
				'select[name=hsf_state]'
			);
			if (createdStateSelect) {
				createdStateSelect.remove();
			}
		}
	}

	stateSelectChangeHandler(e, stateHSNativeField) {
		const target = e.target;
		this.updateHSNativeStateField(
			target.selectedOptions[0].value,
			stateHSNativeField
		);
	}

	updateHSNativeCountryField(value, countryHSNativeField) {
		if (!countryHSNativeField) {
			return;
		}
		jQuery(`#${countryHSNativeField.id}`).trigger('focus').trigger('keyup').trigger('change').trigger('blur');
		countryHSNativeField.value = value;

		const countryKeyupEvent = new Event('keyup');
		countryHSNativeField.dispatchEvent(countryKeyupEvent);
		const countryChangeEvent = new Event('change');
		countryHSNativeField.dispatchEvent(countryChangeEvent);
		jQuery(`#${countryHSNativeField.id}`).trigger('focus').trigger('keyup').trigger('change').trigger('blur');
	}

	updateHSNativeStateField(value, stateHSNativeField = null) {
		if (!stateHSNativeField) {
			return;
		}
		jQuery(`#${stateHSNativeField.id}`).trigger('focus').trigger('keyup').trigger('change').trigger('blur');
		stateHSNativeField.value = value;

		const stateChangeEvent = new Event('change');
		stateHSNativeField.dispatchEvent(stateChangeEvent);
		jQuery(`#${stateHSNativeField.id}`).trigger('change').trigger('blur');
	}
}
